import { jsonRequest } from '../helpers/apiRequest'
import { baseUrl } from '../helpers/baseUrl'
import { getUrlWithQueryString } from '../helpers/util'

export function fetchAvailableMarketingConsents() {
  return jsonRequest(
    `${baseUrl}/configuration/v2/push-notifications/advertisement-status`,
    true
  )
}
export function updateAvailableMarketingConsents(body) {
  return jsonRequest(
    `${baseUrl}/configuration/v2/push-notifications/change-advertisements`,
    true,
    body,
    // {
    //   typeAnswers
    //   // approveAll: true
    // },
    'PUT'
  )
}

export function fetchServiceLimit(params = {}) {
  const url = getUrlWithQueryString(
    `${baseUrl}/Configuration/v1/ServiceLimit`,
    params
  )
  return jsonRequest(url, true)
}
